import { motion } from "framer-motion";

const MOMENTS = [
  {
    img: "/whitehouse-hallway.jpg",
    title: "The White House",
    place: "Washington, D.C.",
    desc: "Invited technology educator and speaker.",
    span: "md:col-span-7",
  },
  {
    img: "/prague-audience.jpg",
    title: "Open Source Summit Europe",
    place: "Prague",
    desc: "Keynote presentation before an international technology audience.",
    span: "md:col-span-5",
  },
  {
    img: "/prague-onstage.jpg",
    title: "Linux Foundation",
    place: "Europe and North America",
    desc: "Technology education programs delivered alongside daughter Keila Banks.",
    span: "md:col-span-5",
  },
  {
    img: "/msnbc-hq.jpg",
    imgClass: "aspect-[16/10] object-[50%_20%]",
    title: "MSNBC Headquarters",
    place: "Philadelphia",
    desc: "Technology and education presentation at corporate headquarters.",
    span: "md:col-span-7",
  },
  {
    img: "/ai-seminar-tedx.jpg",
    imgClass: "aspect-[4/5] object-top",
    title: "AI for Small Business",
    place: "Los Angeles",
    desc: "Practical strategies for entrepreneurs adopting artificial intelligence.",
    span: "md:col-span-5",
  },
];

const LOGOS = [
  ["The White House", "https://www.banksfamilytech.com/images/US-WhiteHouse-Logo.png"],
  ["MSNBC", "https://www.banksfamilytech.com/images/msnbc.png"],
  ["Mayor of Los Angeles", "https://www.banksfamilytech.com/images/mayorLA.png"],
  ["Google", "https://www.banksfamilytech.com/images/Googlelogo.png"],
  ["SCaLE", "https://www.banksfamilytech.com/images/scale_logo.png"],
  ["Comcast", "https://www.banksfamilytech.com/images/Comcast_Logo.png"],
  ["O'Reilly OSCON", "https://www.banksfamilytech.com/images/oscon.png"],
  ["Urban League", "https://www.banksfamilytech.com/images/urbanleague_logo.png"],
];

export default function Stages() {
  return (
    <section id="stages" data-testid="stages-section" className="py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          Speaking & Appearances
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-4xl">
          Technology. Education. Innovation. <span className="italic text-primary">Impact.</span>
        </motion.h2>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-10">
          {MOMENTS.map((m, i) => (
            <motion.figure
              key={m.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: "easeOut" }}
              data-testid={`stage-card-${i}`}
              className={`${m.span} group`}
            >
              <div className="overflow-hidden rounded-xl border border-[#D8D4CA]">
                <img
                  src={m.img}
                  alt={m.title}
                  loading="lazy"
                  className={`w-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out ${m.imgClass || "aspect-[16/10]"}`}
                />
              </div>
              <figcaption className="mt-5">
                <div className="font-display text-2xl tracking-tight">{m.title}</div>
                <div className="text-sm font-semibold text-primary mt-1">{m.place}</div>
                <div className="text-sm text-foreground/60 mt-1">{m.desc}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mt-24"
          data-testid="stages-logo-strip"
        >
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-foreground/50 mb-10">
            As seen on stages & screens
          </p>
          <div className="flex flex-wrap items-center gap-x-14 gap-y-8">
            {LOGOS.map(([name, src]) => (
              <img
                key={name}
                src={src}
                alt={name}
                loading="lazy"
                className="h-10 md:h-12 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-[filter,opacity] duration-300"
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
